var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "LayoutList",
    [
      _c("template", { slot: "header" }, [
        _c(
          "div",
          { staticStyle: { display: "flex", "flex-direction": "column" } },
          [
            _c(
              "router-link",
              {
                staticStyle: { "margin-bottom": "1rem" },
                attrs: { to: `/sectors/${_vm.id}` },
              },
              [_c("span", [_vm._v("Back")])]
            ),
            _vm._v(" "),
            _c("h1", [_vm._v(_vm._s(_vm.sector.name) + " Experts")]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.filters.query,
            expression: "filters.query",
          },
        ],
        staticClass: "form__control",
        attrs: { slot: "search", type: "search", placeholder: "Search..." },
        domProps: { value: _vm.filters.query },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.filters, "query", $event.target.value)
          },
        },
        slot: "search",
      }),
      _vm._v(" "),
      _c("GridUsers", { attrs: { filters: _vm.filters } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }